require('./cmInvestmentFundCell.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
// @components
const {
    OneLineSymbolAmount,
} = require('commonsComponents/oneLineSymbolAmount');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
// @utilities
const { getLanguage } = require('core/i18n').i18n;
const { formatAmountObject } = require('utilities/currencyHelper');

class CmInvestmentFundCell extends React.Component {
    getInvalidFundMessage = invalidFundMessage => {
        const { amount } = invalidFundMessage;
        return (
            <div className="cm-investment-fund-cell__container-name__error">
                <FormattedTextWithComponents
                    value="brokerCM-buyStep1MinFundAmountPerFundError"
                    injectedComponents={[
                        <OneLineSymbolAmount
                            amountObject={amount}
                            key="cmWalletBuyStep2AvailableAmount"
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(
                                invalidFundMessage,
                                true,
                            )}
                        />,
                    ]}
                />
            </div>
        );
    };

    render() {
        const {
            subAssetClassFundName,
            assetClassDesc,
            activeSubclass,
            amount,
            invalidFundMessage,
        } = this.props;

        const invalidFund = invalidFundMessage
            ? this.getInvalidFundMessage(invalidFundMessage)
            : null;

        return (
            <div className="cm-investment-fund-cell">
                <div className="cm-investment-fund-cell__container-name">
                    <span>{subAssetClassFundName}</span>
                    {invalidFund}
                </div>
                <div className="cm-investment-fund-cell__container-class-and-subclass">
                    <span>{`${assetClassDesc} - ${activeSubclass}`}</span>
                </div>
                <div className="cm-investment-fund-cell__container-amount">
                    <span>
                        <OneLineSymbolAmount
                            amountObject={amount}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(
                                amount,
                                true,
                            )}
                        />
                    </span>
                </div>
            </div>
        );
    }
}

CmInvestmentFundCell.propTypes = {
    subAssetClassFundName: PropTypes.string.isRequired,
    assetClassDesc: PropTypes.string.isRequired,
    activeSubclass: PropTypes.string.isRequired,
    amount: PropTypes.object.isRequired,
    invalidFundMessage: PropTypes.string,
};

module.exports = { CmInvestmentFundCell };
